<form [formGroup]="lienDetails">
  <div class="padding">
    @if (uiConfiguration.amendmentConfiguration?.showCorrectionOrChange) {
      <div class="flex-item form-field">
        <div class="validated-form-field-container flex-container">
          <mat-radio-group formControlName="amendmentTypeID"
            [attr.aria-label]="'orders.changeOrCorrectionAmendmentTypeOption' | transloco">
            <mat-radio-button name="change-selection" class="radio-button"
            [value]="change">{{ 'common.buttons.change' | transloco }}</mat-radio-button>
            <mat-radio-button name="correction-selection" class="radio-button" [value]="correction">{{ 'orders.correction' | transloco }}</mat-radio-button>
          </mat-radio-group>
          <lib-error-bubble [control]="lienDetails.controls['amendmentTypeID']"
          [message]="amendmentTypeError$"></lib-error-bubble>
        </div>
      </div>
    }

    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$"
    [order]="order" [isDisabled]="isDisabled"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            @if (uiConfiguration.lienDetailsConfiguration?.showUseDefaultSumOfHypothec) {
              <mat-label>{{ 'orders.amountUsedToCalculateDefaultSum' | transloco }}</mat-label>
            }
            @if (!uiConfiguration.lienDetailsConfiguration?.showUseDefaultSumOfHypothec) {
              <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            }
            <input matInput moneyInput type="text" maxlength="13" data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" formControlName="amount">
            @if (!uiConfiguration.amendmentConfiguration?.showCorrectionOrChange &&
              uiConfiguration.lienDetailsConfiguration?.showSumOfHypothec) {
              <button matSuffix mat-raised-button
                (click)="onCopyAmount()" color="accent" class="margin-sides-15" [attr.aria-label]="'orders.copyAmountButton' | transloco"
                data-testid="copy-amount-button" [disabled]="shouldDisableCopyAmount()">
                {{ 'orders.copyToSumOfHypothec' | transloco }}
              </button>
            }
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
        @if (uiConfiguration.amendmentConfiguration?.showCorrectionOrChange &&
          uiConfiguration.lienDetailsConfiguration?.showSumOfHypothec) {
          <mat-icon color="primary" class="info-icon padding-top-20 margin-sides-15"
            [matTooltip]="'orders.theRdprmOnlyAllowsAChange' | transloco"
          matTooltipClass="reghub-tooltip">info_outline</mat-icon>
        }
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showUseDefaultSumOfHypothec) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" [formControlName]="'useDefaultSumOfHypothec'"
            (change)="useDefaultSumOfHypothecChanged()" data-testid="use-default-sum-of-hypothec-checkbox">
            {{ 'orders.useDefaultSumOfHypothec' | transloco }}
          </mat-checkbox>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showSumOfHypothec) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          @if (isRHa) {
            <mat-form-field class="flex-item form-field" appearance="outline"
              [matTooltip]="'orders.generatedBasedOnProvidedAmountSee' | transloco"
              [matTooltipDisabled]="shouldDisableSumOfHypothecTooltip()"
              matTooltipClass="reghub-tooltip">
              <mat-label>{{ 'orders.sumOfHypothec' | transloco }}</mat-label>
              <textarea matInput [placeholder]="'orders.sumOfHypothec2' | transloco" [formControlName]="'sumOfHypothec'" data-testid="sum-of-hypothetic-field"></textarea>
            </mat-form-field>
          }
          <lib-error-bubble [control]="lienDetails.controls['sumOfHypothec']"
          [message]="sumOfHypothecError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showAdditionalInformation) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.additionalInformation' | transloco }}</mat-label>
            <textarea matInput data-testid="additional-information-field" [formControlName]="'additionalInformation'"
            [placeholder]="'orders.additionalInformation2' | transloco"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['additionalInformation']"
          [message]="additionalInformationError$"></lib-error-bubble>
        </div>
      </div>
    }
  </div>
</form>

@if (uiConfiguration.lienDetailsConfiguration?.showSigningCountry ||
  uiConfiguration.lienDetailsConfiguration?.showSigningJurisdiction ||
  uiConfiguration.lienDetailsConfiguration?.showSigningCity ||
  uiConfiguration.lienDetailsConfiguration?.showSigningDate) {
  <div class="padding">
    <lib-signing-location [errors$]="observableErrors$" [order]="order" [isDisabled]="isDisabled"
    (signingLocationFormValueChangedEvent)="handleSigningLocationFormValueChangedEvent()"></lib-signing-location>
  </div>
}